import Vue from 'vue'
import Vuex from 'vuex'
import ajax from '@/libs/ajax'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
    corpInfo: {},
    hasLogin: false,
    menuList: [],
    screenSize: 'MINI'
  },
  mutations: {
    //
    updateCorpInfo (state, value) {
      state.corpInfo = value
    },
    updateHasLogin(state, value) {
      state.hasLogin = value
    },
    updateMenuList (state, value) {
      state.menuList = value
    },
    updateScreenSize (state, size) {
      state.screenWidth = size.width || 1200
      state.screenHeight = size.height || 600
      state.routerHeight = size.routerHeight || 600
      state.screenSize = size.width && size.width >= 1480 ? 'WIDE' : 'MINI'
    }
  },
  getters: {
    hasLogin: (state) => {
      return state.hasLogin
    }
  },
  actions: {
    getInfo ({ state, commit }) {
      return new Promise(function(resolve, reject) {
        ajax.get('/v1/security').then(res => {
          if (res.code === '0') {
            commit('updateCorpInfo', Object.assign(res.data))
            commit('updateHasLogin', true)
            commit('updateMenuList', res.data.menus)
            resolve(res.data)
          }
        })
      })
    },
    updateScreenSize ({ commit }, size) {
      commit('updateScreenSize', size)
    }
  }
})
